import moment from 'moment/moment'
import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { EuiDatePicker, EuiFieldNumber, EuiForm, EuiFormRow, EuiRadio, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import { RootState } from 'app/rootReducer'
import { setAiRecommendedStartAndDuration, setDurationInMonths, setStartDate } from 'features/planner/CreateMasterCampaignPlanSlice'

export interface SetStartDateAndDurationProps {}

const SetStartDateAndDuration: FC<SetStartDateAndDurationProps> = () => {
  const dispatch = useDispatch()
  const { aiRecommendedStartAndDuration, startDate, durationInMonths } = useSelector((state: RootState) => state.createMasterCampaignPlan)

  const onAiRecommendedStartAndDurationChange = () => {
    dispatch(setAiRecommendedStartAndDuration(true))
  }

  const onCustomStartAndDurationChange = () => {
    dispatch(setAiRecommendedStartAndDuration(false))
  }

  const onStartDateChange = (date: moment.Moment | null) => {
    if (date) {
      dispatch(setStartDate(date))
    }
  }

  return (
    <>
      <EuiTitle size={'s'}>
        <h2>Step 3: Provide Dates and Duration</h2>
      </EuiTitle>
      <EuiText>AdCritter AI will use these dates to build campaigns that factor in seasonality and cyclical patterns throughout the year.</EuiText>

      <EuiSpacer />

      <EuiRadio id={'ai-recommended-start-duration'} onChange={onAiRecommendedStartAndDurationChange} checked={aiRecommendedStartAndDuration} label={'Let AdCritter AI recommend start date & duration.'} />
      <EuiRadio id={'custom-start-duration'} onChange={onCustomStartAndDurationChange} checked={!aiRecommendedStartAndDuration} label={'Use a custom start date & duration.'} />

      {!aiRecommendedStartAndDuration && (
        <>
          <EuiSpacer />

          <EuiForm>
            <EuiFormRow label='Start Date'>
              <EuiDatePicker fullWidth selected={moment(startDate)} dateFormat='MM/DD/yyyy' onChange={onStartDateChange} minDate={moment().add(3, 'days')} showTimeSelect={false} />
            </EuiFormRow>
            <EuiFormRow label='Duration (in months)'>
              <EuiFieldNumber placeholder='Enter duration' value={durationInMonths || ''} onChange={e => dispatch(setDurationInMonths(Number(e.target.value)))} />
            </EuiFormRow>
          </EuiForm>
        </>
      )}
    </>
  )
}

export default SetStartDateAndDuration
